import { render, staticRenderFns } from "./GroupRewardInfoModal.vue?vue&type=template&id=4d4126ec&"
import script from "./GroupRewardInfoModal.vue?vue&type=script&lang=js&"
export * from "./GroupRewardInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports